module.exports = __webpack_public_path__ + "img/sld_LT_2.09fd8f0b.svg";